// import requests from "./httpService";
import requests from "./httpService";
const EventCategoryServices = {
  getEventCategory: async (page = 1, limit = 20) => {
    return requests.get(
      `/event-ticket/all?page=${page}&limit=${limit}`
    );
  },

  getActiveCategories: async () => {
    return requests.get("/event-ticket/active");
  },

  // Get single category details
  getEventCategoryById: async (id) => {
    return requests.get(`/event-ticket/${id}`);
  },

  createEventCategory: async (body) => {
    return requests.post("/event-ticket/create", body);
  },

  // Update category status
  updateEventCategoryStatus: async (id, body) => {
    return requests.put(`/event-ticket/${id}/status`, body);
  },
  updateEventCategory: async (id, body) => {
    return requests.put(`/event-ticket/${id}`, body);
  },

  // Delete category
  deleteEventCategory: async (id) => {
    return requests.delete(`/event-ticket/${id}`);
  },
};

export default EventCategoryServices;